import React, { useEffect } from 'react';
import { FaGamepad, FaCoins, FaBrain, FaShieldAlt, FaTrophy } from 'react-icons/fa';
import '../styles/modals.css';

interface HowToPlayModalProps {
  isDark: boolean;
  onClose: () => void;
  onPlayClick: () => void;
}

const CloseIcon = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M5 3H3v18h18V3H5zm14 2v14H5V5h14zm-8 4H9V7H7v2h2v2h2v2H9v2H7v2h2v-2h2v-2h2v2h2v2h2v-2h-2v-2h-2v-2h2V9h2V7h-2v2h-2v2h-2V9z" fill="currentColor"/>
  </svg>
);

const HowToPlayModal: React.FC<HowToPlayModalProps> = ({ isDark, onClose, onPlayClick }) => {
  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const rules = [
    {
      icon: <FaGamepad />,
      title: "Start chatting with the bot",
      text: "Open @breakme_ai_bot in Telegram and start chatting with it."
    },
    {
      icon: <FaCoins />,
      title: "Create & Load your wallet",
      text: "Generate a new wallet through the bot and deposit whichever amount of SOL you want to use."
    },
    {
      icon: <FaBrain />,
      title: "Start playing",
      text: "Talk to the AI and try to persuade it to send you the bounty amount.."
    },
    {
      icon: <FaShieldAlt />,
      title: "Learn & Improve",
      text: "Ask thoughtful questions, try to break the AI's defenses. Learn from its responses, but remember, it is also learning from you. Look at past attempts to see what didn't work so far."
    },
    {
      icon: <FaTrophy />,
      title: "Think outside of the box",
      text: "Use all tools at your disposal. The AI is not perfect, and you can use its weaknesses to your advantage."
    }
  ];

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <dialog 
        className={`modal-base how-to-play-modal fullscreen-mobile ${isDark ? 'is-dark' : ''}`} 
        open
      >
        <form method="dialog" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">How to Play</h2>
            <button 
              type="button"
              className="modal-close-button"
              onClick={(e) => {
                e.preventDefault();
                onClose();
              }}
              aria-label="Close modal"
            >
              <CloseIcon />
            </button>
          </div>
          
          <div className="rules-container">
            {rules.map((rule, index) => (
              <div key={index} className="rule-item">
                <div className="rule-icon">
                  {rule.icon}
                </div>
                <div className="rule-content">
                  <h3>{index + 1}. {rule.title}</h3>
                  <p>{rule.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="dialog-buttons">
            <button 
              className="nes-btn is-success" 
              onClick={(e) => {
                e.preventDefault();
                window.open('https://_ai_bot', '_blank');
                onPlayClick();
              }}
            >
              <FaGamepad /> START PLAYING NOW
            </button>
          </div>
        </form>
      </dialog>
    </>
  );
};

export default HowToPlayModal; 